export default __webpack_public_path__ + "media/f77498e7a944f61cfa651fb00cb5957bc45cd7de3afd9faacca91a002554251a.svg";